import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { Modal, Progress, Button, Icon, message } from 'antd';

import CONSTANT from '../../constant';
import Emitter from '../../services/emitter';

import History from '../../util/history';
import mElectronApi from '../../util/electron';
import UploadAction from '../../reducers/upload/action';
import { editingTarget } from '../../services/mscratch/ext';
import MScratch from '../../services/mscratch';
import formatMessage from '../configui/lang';

import './index.less';

const { UPLOAD_STATUS } = CONSTANT;

class Upload extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            logs: [],
            prettyLogs: []
        };
        this.isRetry = false;
        this.upload = null;
        this.getEditingTarget();
        this.initListeners();
    }

    componentDidMount() {
        if (!_.isEmpty(this.props.upload)) {
            this.doUploadCode();
        }
    }

    componentWillUnmount() {
        for (const key in this.listeners) {
            Emitter.removeListener(key, this.listeners[key]);
        }
        this.props.onReady();
    }

    getEditingTarget = () => {
        try {
            const target = editingTarget();
            this.upload = target.config.options.upload;
        } catch (e) {
            console.log(e);
        }
    }

    initListeners() {
        this.listeners = {
            CompilerLog: (msg) => {
                const { logs } = this.state;
                logs.push(msg);
                this.setState({
                    logs
                }, () => {
                    this.logContainer.scrollTop = this.logContainer.scrollHeight;
                });
            },
            ConnectBroken: () => {
                this.broken = true;
            },
            UploadCodeProgress: (err, data) => {
                this.props.uploadCodeProgress(err, data);
            },
            UploadedCode: () => {
                const { intlr } = this.props;
                _.delay(() => {
                    message.success(intlr.messages['UPLOAD.MESSAGE.SUCCESS']);
                    Emitter.emit('UploadCodeSuccess', this.isRetry);
                    History.replace('/');
                }, 600);
            },
            UploadCodeFail: () => {
                const { intlr } = this.props;
                if (!this.broken) {
                    this.props.uploadCodeFail();
                    message.error(intlr.messages['UPLOAD.MESSAGE.FAIL']);
                    Emitter.emit('UploadCodeFailed', this.isRetry);
                }
            },
            CompileFailed: () => {
                const { intlr } = this.props;
                this.props.uploadCodeFail();
                message.error(intlr.messages['UPLOAD.COMPLIE.FAILED']);
            }
        };

        for (const key in this.listeners) {
            Emitter.on(key, this.listeners[key]);
        }
    }

    doUploadCode = (isRetry = false) => {
        if (isRetry) {
            MScratch.uploadRetry();     // 重试的时候出发ide
        } else {
            this.props.uploadCode();
        }
        this.isRetry = isRetry;
    }

    status() {
        const { progress_status } = this.props.upload;
        if (progress_status === UPLOAD_STATUS.UPLOADED) {
            return 'success';
        }
        return 'active';
    }

    handleCancel() {
        History.replace('/');
    }

    render() {
        const { logs } = this.state;
        const { upload, intlr } = this.props;
        if (_.isEmpty(upload)) {
            this.handleCancel();
            return null;
        }
        const { progress_percent, progress_status } = upload;
        const isCompiling = progress_status === UPLOAD_STATUS.COMPILING;
        const isFail = progress_status === UPLOAD_STATUS.FAILED;
        // const successTips = this.upload.tips && this.upload.tips.success;
        const failTips = this.upload && this.upload.tips && this.upload.tips.fail || [];
        const helpLink = this.upload && this.upload.helpLink || '';
        return (
            <Modal
                visible={true}
                width={360}
                title={intlr.messages[`UPLOAD.${isCompiling ? 'COMPLIE' : 'CODE'}.TITLE`]}
                maskClosable={false}
                keyboard={false}
                closable={progress_status !== UPLOAD_STATUS.PROCESSING && progress_status !== UPLOAD_STATUS.COMPILING}
                onCancel={this.handleCancel.bind(this)}
                footer={null}>
                {
                    isCompiling
                        ? <p style={{ textAlign: 'center' }}><Icon style={{ fontSize: '2rem' }} type="loading" /></p>
                        : <div className="flex-row progress-inner">
                            <Progress percent={progress_percent} status={this.status()} showInfo={!isFail} />
                            {isFail && <i className="mblock-icon icon-wangluoyichangchengseV fail-icon" />}
                        </div>
                } {
                    isFail &&
                    <ul className="helpTip fail">
                        {
                            failTips.map((tip, index) => (
                                <li key={index}>{formatMessage(tip)}</li>
                            ))
                        } {
                            helpLink &&
                            <li>
                                {intlr.messages['CONNECT.PROBLEM.TIP']}
                                <a href={helpLink}
                                    rel="nofollow me noopener noreferrer"
                                    target="_blank"
                                    onClick={(e) => mElectronApi.openLink(e, helpLink)}>
                                    {intlr.messages['CONNECT.HELPLINK.TEXT']}
                                </a>
                            </li>
                        }
                    </ul>
                } {!_.isEmpty(logs)
                    ? (
                        <section className="compile-log" ref={logContainer => this.logContainer = logContainer}>
                            {logs.map((log, idx) => {
                                let errorKeys = ['error', 'fail'];
                                let classname = 'log';
                                for (let key of errorKeys) {
                                    if (log.toLowerCase().includes(key)) {
                                        classname = 'log error';
                                        break;
                                    }
                                }
                                return (<p className={classname} key={idx}>{log}</p>);
                            })}
                        </section>
                    )
                    : null
                } {
                    isFail
                        ? (
                            <div style={{ textAlign: 'center', marginBottom: 10 }}>
                                <Button type="primary" block style={{ minWidth: '10rem' }} onClick={() => this.doUploadCode(true)}>
                                    {intlr.messages['BUTTON.RETRY.TEXT']}
                                </Button>
                            </div>
                        )
                        : null
                }
            </Modal>
        );
    }
}

const mapStateToProps = state => ({
    intlr: state.intlr,
    upload: state.upload
});

const mapDispatchToProps = dispatch => ({
    onReady: () => dispatch(UploadAction.uploadCodePrepare()),
    uploadCodeFail: () => dispatch(UploadAction.uploadCodeFail()),
    uploadCode: (uploadedCb, failedCb) => dispatch(UploadAction.uploadCode(uploadedCb, failedCb)),
    uploadCodeProgress: (err, data) => dispatch(UploadAction.uploadCodeProgress(err, data))
});

export const UploadCmp = Upload;

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Upload);